import { apiGetRequest, apiPostRequest, cdnGetRequest } from "../utils/webrequests";
import { ConferenceInfo } from "../data/conferenceInfo";

export async function getConferenceInfo(): Promise<ConferenceInfo>{
        const data:ConferenceInfo = await apiGetRequest("GetConferenceInfo",null);
        return data;
};
export async function saveConferenceInfo(conferenceInfo: ConferenceInfo): Promise<any>{
        const data:ConferenceInfo = await apiPostRequest("ConferenceInfo",conferenceInfo);
        return data;
};
export async function savePrivacy(privacyStatement: string): Promise<any>{
        const data:ConferenceInfo = await apiPostRequest("Privacy",privacyStatement);
        return data;
};
export async function saveCodeOfConduct(codeOfConduct: string): Promise<any>{
        const data:ConferenceInfo = await apiPostRequest("CodeOfConduct",codeOfConduct);
        return data;
};

  // Validation function for name
export const validateName = (name: string) => {
        // Validation logic for name (example: not empty)
        return name.trim() !== "";
};
    
// Validation function for address 1
export const validateAddress1 = (address1: string) => {
        // Validation logic for address 1 (example: not empty)
        return address1 !== null && address1.trim() !== "";
};

// Validation function for address 2
export const validateAddress2 = (address2: string | null) => {
        // Validation logic for address 2 (example: optional, always valid)
        return true;
};

// Validation function for phone number
export const validatePhone = (phone: string) => {
        // Validation logic for phone number (example: exactly 9 digits)
        return (
                /^\d{10}$/.test(phone.replace(/-/g, "")) ||
                /^\d{3}-\d{3}-\d{4}$/.test(phone)
        );
};

// Validation function for email address
export const validateEmail = (email: string) => {
        // Validation logic for email address (example: basic format check)
        return (
                email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
        );
};

// Validation function for city
export const validateCity = (city: string) => {
        // Validation logic for city (example: not empty)
        return city.trim() !== "";
};

// Validation function for state
export const validateState = (state: string) => {
        // Validation logic for state (example: not empty)
        return state.trim() !== "";
};

// Validation function for zip code
export const validateZip = (zip: string) => {
        // Validation logic for zip code (example: exactly 5 digits)
        return /^[0-9]{5}$/.test(zip);
};

// Validation function for image
export const validateImage = (image: string) => {
        // Validation logic for image (example: not empty)
        return image.trim() !== "";
};